//Core
import React from "react"

//Components
import Layout from "../../container/Layout"
import Travel from "../../modules/travel"

//Styles
import "../../styles/main.scss"

const PudraPage = () => {
  return (
    <Layout
      hideHeader={true}
      title={`Акція: виграй подорож своєї мрії!`}
      description={`Тільки для справжніх чоловіків:  купуйте подарунки на 8 березня і вигравайте подорож до будь-якої країни світу`}
      link={`https://tascombank.ua/promo/travel/`}
    >
      <Travel></Travel>
    </Layout>
  )
}

export default PudraPage
